module.exports = __webpack_public_path__ + "img/1543962902.a337593e.jpg";